function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlayArrowLogo = function SvgGooglePlayArrowLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "30 336.7 120.9 129.2",
    style: {
      enableBackground: "new 30 336.7 120.9 129.2"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M119.2 421.2c15.3-8.4 27-14.8 28-15.3 3.2-1.7 6.5-6.2 0-9.7-2.1-1.1-13.4-7.3-28-15.3l-20.1 20.2 20.1 20.1z",
    style: {
      fill: "#ffd400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.1 401.1-64.2 64.7c1.5.2 3.2-.2 5.2-1.3 4.2-2.3 48.8-26.7 79.1-43.3l-20.1-20.1z",
    style: {
      fill: "#f33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.1 401.1 20.1-20.2s-74.6-40.7-79.1-43.1c-1.7-1-3.6-1.3-5.3-1l64.3 64.3z",
    style: {
      fill: "#48ff48"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.1 401.1-64.3-64.3c-2.6.6-4.8 2.9-4.8 7.6v113.8c0 4.3 1.7 7.4 4.9 7.7l64.2-64.8z",
    style: {
      fill: "#3bccff"
    }
  }));
};
export default SvgGooglePlayArrowLogo;